import classes from './procenaVrednostiTiketa.module.css'
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import add from '../images/add.svg'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import runCalculator from '../api/runCalculator'

const ProcenaVrednostiTiketa = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [apiError, setApiError] = useState('')
  const [data, setData] = useState({
    values: {
      serie1: {
        ticket: ['', '', ''],
      },
      percent: [''],
    },
    results: ['', '', ''],
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: {
          ticket: ['', '', ''],
        },
        percent: [''],
      },
      results: ['', '', ''],
    })
    setApiError('')
    setShowInputArea(true)
    setSeries([{ id: 1 }])
  }

  const [series, setSeries] = useState([{ id: 1 }])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => {
        const newSerieKey = `serie${newSeries.length}`
        return {
          ...prevData,
          values: {
            ...prevData.values,
            [newSerieKey]: {
              ticket: ['', '', ''],
            },
          },
          results: {
            ...prevData.results,
            [`${newSerieKey}Results`]: ['-', '-', '-'],
          },
        }
      })
      return newSeries
    })
  }

  const buildBody = () => {
    const percent = parseFloat(data.values.percent[0]) || 0

    // Get all series keys dynamically
    const seriesKeys = Object.keys(data.values).filter((key) =>
      key.startsWith('serie')
    )

    // Extract and parse valid odds
    const oddsList = seriesKeys
      .map((key) => {
        const ticket = data.values[key]?.ticket?.[2]
        const parsed = parseFloat(ticket)
        return isNaN(parsed) ? null : parsed
      })
      .filter((odd) => odd) // Filter out nulls

    return {
      oddsList,
      bookmakerMargin: percent,
    }
  }

  const calculateAll = async () => {
    const percent = parseFloat(data.values.percent[0]) || 0

    if (!percent) {
      setShowInputArea(false)
      return
    }

    setLoading(true)
    setApiError('')

    try {
      const result = await runCalculator('odds', 'ticket-value', buildBody())

      setData((prevData) => ({
        ...prevData,
        results: [
          result.averageOdds.toFixed(2),
          result.averageOddsPct.toFixed(2),
          result.expectedWinningLegs.toFixed(2) + ` / ${series.length}`,
        ],
      }))
      setShowInputArea(false)
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  const toggleInputArea = async () => {
    if (!showInputArea) {
      clearFields()
      return
    }

    await calculateAll()
  }

  useEffect(() => {
    const firstSeries = data.values.serie1.ticket
    const allFieldsHaveValue = firstSeries.every(
      (value, index) => value !== '' && (index !== 2 || value > 0)
    )
    console.log(
      'First series:',
      firstSeries,
      'All fields have value:',
      allFieldsHaveValue
    )

    setDisabled(!allFieldsHaveValue)
  }, [data.values])

  useEffect(() => {
    console.log(showInputArea)
  }, [showInputArea])

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Procena vrednosti tiketa`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled || loading}>
            {showInputArea
              ? loading
                ? 'Obračun u toku...'
                : 'Prikaži rezultate'
              : 'Unesi obračunske podatke'}
          </button>
        </div>
        {apiError && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '8px' }}>
            {apiError}
          </div>
        )}
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Prosečna marža kladionice
              </div>
              <div
                className={`${classes.seriesContainer} ${classes.seriesContainerOne}`}
              >
                <div className={`${classesK.calcButton} ${classes.calcButton}`}>
                  Upiši od 3% do 5%
                </div>
                <div
                  className={`${classesK.oddsContainer} ${classes.oddsContainerOne}`}
                >
                  <span>Upiši br. % od 3 do 5</span>
                  <input
                    type='number'
                    value={data?.values?.percent || ''}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)

                      setData((prevData) => ({
                        ...prevData,
                        values: {
                          ...prevData.values,
                          percent: [value],
                        },
                      }))
                    }}
                  />
                </div>
              </div>

              <div className={classesK.sectionTitle}>Tvoj tiket</div>
              {series.map((serie) => (
                <>
                  <div key={serie.id} className={classes.seriesContainer}>
                    <div
                      className={`${classesK.calcButton} ${classes.calcButton}`}
                    >
                      Par br. {serie.id}
                    </div>
                    <div className={classes.seriesValues}>
                      <div className={classes.oddsContainer}>
                        <div className={classesK.oddsContainer}>
                          <span>Upiši imena timova</span>
                          <input
                            type='text'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[0] || ''
                            }
                            onChange={(e) => {
                              const value = e.target.value

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      value,
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[1],
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[2],
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                        <div className={classesK.oddsContainer}>
                          <span>IGRA</span>
                          <input
                            type='text'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[1] || ''
                            }
                            onChange={(e) => {
                              const value = e.target.value

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[0],
                                      value,
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[2],
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                        <div className={classesK.oddsContainer}>
                          <span>KVOTA</span>
                          <input
                            type='number'
                            min='0'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[2] || ''
                            }
                            onChange={(e) => {
                              const value = parseFloat(e.target.value)

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[0],
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[1],
                                      value,
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
        {!showInputArea && (
          <div className={classes.resultsWrapper}>
            <ResultsSection
              title={`Predikcija prolaznosti na tiketu`}
              subtitle={`Obračunati podaci`}
              names={[
                'Srednja kvota tiketa',
                'Procenat srednje kvote',
                'Prosečan broj prolaznih parova',
              ]}
              results={[
                data.results[0] ? data.results[0] : '-',
                data.results[1] ? `${data.results[1]}%` : '-',
                data.results[2] ? data.results[2] : '-',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProcenaVrednostiTiketa
